import { Component, input } from '@angular/core';
import { AbstractControl, FormsModule } from '@angular/forms';
import { CalculateValidationTextFn, ControlSupportingTextComponent } from '../../internal/control-supporting-text/control-supporting-text.component';
import { ControlLabelComponent } from '../../internal/control-label/control-label.component';
import { LayoutHorizontalControlComponent } from '../../internal/layout-horizontal-control/layout-horizontal-control.component';

@Component({
  selector: 'app-right-side-decorator',
  standalone: true,
  imports: [FormsModule, ControlLabelComponent, ControlSupportingTextComponent, LayoutHorizontalControlComponent],
  templateUrl: './right-side-decorator.component.html',
  styleUrl: './right-side-decorator.component.scss'
})
export class RightSideDecoratorComponent {
  readonly caption = input.required<string>();
  readonly control = input<AbstractControl<unknown, unknown> | null>(null);
  readonly infoText = input<string>('');
  readonly inputId = input<string | null>(null);
  readonly calculateValidationText = input<CalculateValidationTextFn | string>();

  get isValid(): boolean {
    const control = this.control();
    const isValid = !control || (control.invalid !== true || (control.pristine && control.untouched));
    return isValid;
  }
}
